module.exports = __webpack_public_path__ + "img/udon.cad55b05.jpg";